<template>
  <section class="root-wrap layout" v-loading="isLoading">
    <aside
      v-show="!isLoading"
      class="menu-wrap"
      :class="{ 'is-collapse': isCollapse }"
    >
      <div class="collapse-ctl" @click="$_doCollapse">
        <i class="icon-arrow" :class="{ 'icon-arrow-right': isCollapse }"></i>
        <span v-show="!isCollapse" class="collapse-txt">收起侧边栏</span>
      </div>
      <el-menu
        :default-active="activeClass"
        :unique-opened="true"
        :collapse-transition="true"
        :popper-append-to-body="true"
        :hide-timeout="50"
        :collapse="isCollapse"
        class="menu-area"
        ref="menu"
      >
        <!-- 欢迎页 -->
        <el-menu-item @click="$_addTab(welcomeTab)" index="/welcome">
          <i class="cd-icon__welcome"></i>
          <span slot="title">欢迎页</span>
        </el-menu-item>

        <!-- 存在二级目录 -->
        <el-submenu
          v-for="menu in functionList"
          :key="menu.code"
          :index="menu.url"
          v-if="menu.children.length > 0"
        >
          <template slot="title">
            <i :class="menu.icon"></i>
            <span slot="title">{{ menu.name }}</span>
          </template>
          <el-menu-item-group>
            <el-menu-item
              v-for="child in menu.children"
              :key="child.code"
              @click="$_addTab(child)"
              :index="child.url"
              >{{ child.name }}</el-menu-item
            >
          </el-menu-item-group>
        </el-submenu>

        <!-- 一级目录 -->
        <el-menu-item v-else :index="menu.url" @click="$_addTab(menu)">
          <i :class="menu.icon"></i>
          <span slot="title">{{ menu.name }}</span>
        </el-menu-item>
      </el-menu>
    </aside>

    <section v-show="!isLoading" class="container-wrap layout">
      <!-- container 头部 - start -->
      <header class="header-wrap">
        <div class="system-name">PaaS配置后台</div>
        <div
          class="is-logined"
          @mouseover="$_showUserInfo"
          @mouseout="$_hideUserInfo"
        >
          <span class="welcome__text">{{ "欢迎您, " + userName }}</span>
          <i class="icon-favor">
            <!-- 头像 -->
          </i>
          <transition name="zoom-in-top">
            <div class="logined-drop" v-show="isShowUserInfo">
              <!-- <div class="logined-drop"> -->
              <h3>Welcome!</h3>
              <!-- 用户信息 -->
              <div
                class="user-info"
                v-show="
                  !isShowChangePwd && !isShowBindPhone && !isShowUntyingPhone
                "
              >
                <p>登录账号 : {{ accountName }}</p>
                <p>用户名 : {{ userName }}</p>
                <p v-show="email !== ''">邮箱 : {{ email }}</p>
                <p v-show="phone !== ''">手机 : {{ phone | formatPhone }}</p>
                <p
                  v-show="phone !== ''"
                  class="untying"
                  @click="isShowUntyingPhone = true"
                >
                  解绑
                </p>
                <div class="user-btns">
                  <el-button
                    @click="isShowChangePwd = true"
                    class="change-pwd__btn"
                    >修改密码</el-button
                  >
                  <el-button
                    @click="isShowBindPhone = true"
                    class="change-pwd__btn"
                    >{{ phone === "" ? "绑定手机" : "修改手机" }}</el-button
                  >
                </div>
              </div>
              <div
                class="logout-box"
                v-show="
                  !isShowChangePwd && !isShowBindPhone && !isShowUntyingPhone
                "
              >
                <button @click.stop="$_logout" class="logout__btn">
                  退出登录
                </button>
              </div>

              <div
                v-show="
                  isShowChangePwd || isShowBindPhone || isShowUntyingPhone
                "
                class="change-pwd__wrapper"
              >
                <button
                  @click="
                    (isShowChangePwd = false),
                      (isShowBindPhone = false),
                      (isShowUntyingPhone = false)
                  "
                  class="close__btn"
                >
                  <span>&times;</span>
                </button>
                <!-- 修改密码 -->
                <change-password v-if="isShowChangePwd"></change-password>
                <!-- 绑定手机 -->
                <bind-phone
                  v-if="isShowBindPhone"
                  :boundPhone="phone"
                  @callback="isShowBindPhone = false"
                ></bind-phone>
                <!-- 解绑手机 -->
                <untying-phone
                  v-if="isShowUntyingPhone"
                  :boundPhone="phone"
                  :accountName="accountName"
                  :email="email"
                  @callback="isShowUntyingPhone = false"
                ></untying-phone>
              </div>

              <div class="popper__arrow"></div>
            </div>
          </transition>
        </div>
      </header>
      <!-- container 头部 - end -->
      <!-- 主页面部分 - start -->
      <main class="main-wrap">
        <div class="tabs-box">
          <!-- 标签 -->
          <div class="tabs-nav-wrapper">
            <div class="open-board">
              <i class="icon-menu"></i>
            </div>

            <el-tabs
              class="tabs-nav-box"
              v-model="currentTab"
              @tab-click="$_selectTab"
              @tab-remove="$_removeTab"
            >
              <el-tab-pane
                v-for="tab in tabs"
                :key="tab.code"
                :closable="tab.fid > 0"
                :label="tab.name"
                :name="tab.code"
              ></el-tab-pane>
            </el-tabs>
          </div>
          <!-- 路由内容部分 -->
          <div class="content-wrapper">
            <keep-alive :include="include">
              <router-view class="content-page"></router-view>
            </keep-alive>
            <div id="appContainer" v-show="!$route.name"></div>
          </div>
        </div>
      </main>
      <!-- 主页面部分 - start -->
    </section>
  </section>
</template>

<script>
import Axios from "axios";
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
import * as TYPES from "@/store/types";
import * as Utils from "@/plugins/utils";
import ifvisible from "@/plugins/ifvisible";
import ChangePassword from "@/components/change-password";
import BindPhone from "@/components/bind-phone";
import UntyingPhone from "@/components/untying-phone";
import { start, initGlobalState } from 'qiankun'

export default {
  name: "main-page",
  data() {
    return {
      isLoading: false,
      isCollapse: false,
      activedIndex: 1,
      timeout: null,
      activeClass: "",
      isShowUserInfo: false,
      isShowChangePwd: false,
      isShowBindPhone: false,
      isShowUntyingPhone: false,
      welcomeTab: {
        url: "/welcome",
        fid: -1,
        code: "welcome",
        name: "欢迎页",
      },
      tabs: [],
      currentTab: "",
    };
  },
  methods: {
    $_doCollapse() {
      this.functionList.forEach((menu) => {
        this.$refs["menu"].close(menu.url);
      });
      this.isCollapse = !this.isCollapse;
    },
    $_addTab(item) {
      if (!this.tabs.some((t) => t.code === item.code)) {
        this.tabs.push(item);
      }
      this.currentTab = item.code;
      this.$nextTick(() => {
        this.$router.replace({ path: item.url });
      });
    },

    $_selectTab(target) {
      const currentTab = this.tabs[target.index];
      this.currentTab = currentTab.code;
      currentTab.url !== this.$route.path &&
      this.$router.replace({ path: currentTab.url });
    },
    $_removeTab(tab) {
      let index = this.tabs.findIndex((item) => item.code === tab);
      let path = this.tabs[index - 1].url;
      this.currentTab = this.tabs[index - 1].code;
      this.tabs.splice(index, 1);
      path !== this.$route.path && this.$router.replace({ path });
    },
    // 退出登录
    async $_logout() {
      this.isLoading = true;
      await this.logout();
      
      Utils.data.remove('horsemanImportMapping'+this.aid)
      Utils.data.remove('horsemanMapping'+this.aid)
      Utils.data.remove('horsemanCustom'+this.aid)
      window.location.href = "/";
    },
    $_showUserInfo() {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.isShowUserInfo = true;
      }, 250);
    },
    $_hideUserInfo() {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        !this.isShowChangePwd &&
          !this.isShowBindPhone &&
          !this.isShowUntyingPhone &&
          (this.isShowUserInfo = false);
      }, 250);
    },

    ...mapMutations({
      setUserInfo: TYPES.SET_USER,
      setLoginuUrl: TYPES.SET_LOGINURL
    }),

    ...mapActions({
      logout: TYPES.LOGOUT,
      isUnifiedSwitch: TYPES.GET_UNIFIED_SWITCH,
    }),
  },
  filters: {
    formatPhone(value) {
      let len = value.length;
      let x = value.substring(3, len - 4);
      let values = value.replace(x, "****");
      return values;
    },
  },

  async created() {
    const $this =this
    this.isLoading = true;

    // 是否走统一登录
    this.isUnifiedSwitch()

    // 使用spas(T), paas(F)登录功能
    let url = '/LocalAction?method=isLogin'
    //第一次获取到auth页面传过来的值
    // 使用spas(T), paas(F)登录功能
    let sso = Utils.url.sso || Utils.data.S.get('sso')//优先获取链接上的参数
    if(sso){
      url += '&sso=' + sso
    }
    let loginResult = await Axios.post(url); //删除sso
    Utils.data.S.remove('sso')//第一次用完删除，服务端记录状态

    let { loginUrl, isSSO } = loginResult.data.data
    loginUrl && this.setLoginuUrl(loginUrl)
    if (loginResult.data.status !== 1) {
      if(loginUrl == ''){
        $MessageBox.alert({
          content: '登录地址为空，跳转失败！'
        })
        return false
      }
     
      window.location.replace(loginUrl)
      // window.location.replace('/login.html')
      return false;
    }

    await this.$service.post("getUserInfo", { systemCode: "paas" }).then((result) => {
      this.isLoading = false;
      if (result.status === 1) {
        this.setUserInfo(result.data);
        const path = this.$route.path;
        if (path !== "/welcome") {
          this.$router.replace({ path: "/welcome" });
        }
        this.tabs.push(this.welcomeTab);
        this.currentTab = "welcome";
      } else {
        $MessageBox.alert({
          content: result.msg,
          onOk () {
            $this.logout().then((res) => {
              window.location.replace("/");
            });
          }
        })
      }
    });

    // spas登录
    if (isSSO) {
      // 传值给微应用
      const { appId, systemKey, systemSecret, token } = this.userInfo.sscConfig
      const params = {
        systemKey,
        appId,
        token,
        secret: systemSecret,
        loginUrl: this.loginUrl,
				idBelongSystemCode: 'paas'
      }
      const actionsQk = initGlobalState(params)

      actionsQk.onGlobalStateChange(state => {
        // state: 变更后的状态; prev 变更前的状态
        if (state.onLine === false) {
          // 退出登录
          this.logout().then(() => {
            window.location.replace('/')
          })
        }
      })

      if (!window.isQiankunStart) {
        window.isQiankunStart = true
        start()
      }
    }
  },

  components: {
    ChangePassword,
    BindPhone,
    UntyingPhone,
  },
  computed: {
    include() {
      let includes = [];
      this.tabs.forEach((tab) => {
        includes.push(tab.url.substring(1).replace("/", "-"));
      });
      return includes;
    },
    ...mapState({
      accountName: (state) => state.user.user.accountName,
      userName: (state) => state.user.user.userName,
      email: (state) => state.user.user.email || "",
      roleName: (state) => state.user.user.roleName,
      phone: (state) => state.user.user.phone || "",
      userInfo: (state) => state.user.user
    }),
    ...mapGetters({
      // 把 `this.functionList` 映射为 `this.$store.getters.menu`
      functionList: "menu",
      aid: 'aid'
    }),
  },
  watch: {
    tabs: {
      handler(val) {
        Utils.data.S.set("tabs", val);
      },
      immediate: true,
    },
    $route(to, from) {
      this.isShowUserInfo = false;
      this.isShowChangePwd = false;
      this.isShowUntyingPhone = false;
      if (to.meta.activePath) {
        this.activeClass = to.meta.activePath;
      } else {
        this.activeClass = to.path;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/mixins.scss";
.layout {
  display: flex;
  flex: auto;
  flex-direction: column;
}
.root-wrap {
  height: 100%;
  /* min-height: 800px; */
  &.layout {
    flex-direction: row;
  }
}
// 左侧容器 - 菜单栏
.menu-wrap {
  width: 255px;
  min-width: 255px;
  max-width: 255px;
  flex: 0 0 255px;

  background-color: #26282e;
  z-index: 99;
  transition: all 0.2s;

  .collapse-ctl {
    position: relative;
    height: 50px;
    line-height: 50px;
    padding: {
      left: 24px;
    }
    background-color: #24252a;
    cursor: pointer;
    overflow: hidden;

    .icon-arrow {
      display: inline-block;
      vertical-align: middle;
      width: 13px;
      height: 12px;
      background: url(~@/assets/images/menu-arrow-left.png) no-repeat center;
      &.icon-arrow-right {
        background-image: url(~@/assets/images/menu-arrow-right.png);
      }
    }
    .collapse-txt {
      display: none;
      margin: {
        left: 18px;
      }
      color: #fff;
      vertical-align: middle;
    }
    &:hover {
      .collapse-txt {
        display: inline-block;
      }
    }
  }

  .menu-area {
    overflow-y: auto;
    height: calc(100% - 50px);
  }

  &.is-collapse {
    width: 55px;
    min-width: 55px;
    max-width: 55px;
    overflow: hidden;
    .el-menu {
      width: 72px;
      > .el-menu-item {
        > span {
          display: none;
        }
        &.is-active {
          color: #fff;
          background-color: #2b2d32;
        }
      }

      .el-submenu {
        padding: {
          bottom: 0px;
        }

        &.is-active {
          .el-submenu__title i {
            color: #fff;
          }
        }

        .el-submenu__title {
          > span {
            display: none;
          }
        }
      }
    }
  }
}
// 右侧容器
.container-wrap {
  overflow-x: hidden;

  .header-wrap {
    position: relative;
    flex: 0 0 auto;
    height: 50px;
    line-height: 50px;
    padding-right: 20px;
    font-size: 14px;
    text-align: right;
    color: #535b65;

    .system-name {
      position: absolute;
      left: 20px;
      color: #526d87;
      font-size: 26px;
      font-weight: bold;
    }

    .is-logined {
      position: relative;
      font-size: 14px;
      display: inline-block;
      vertical-align: top;
      cursor: pointer;
      .welcome__text,
      .icon-favor {
        display: inline-block;
        vertical-align: middle;
        margin-left: 20px;
      }
      .icon-favor {
        width: 36px;
        height: 35px;
        background-position: center;
        background-repeat: no-repeat;
        background-image: url(~@/assets/images/favor-default.png);
      }
      // 用户信息
      .logined-drop {
        position: absolute;
        top: 60px;
        right: 0px;
        text-align: center;
        width: 250px;
        height: 280px;
        background-color: #fff;
        border: 1px solid #f2f5f8;
        box-shadow: 1px 1px 10px #b7b7b7;
        z-index: 99;
        font-size: 13px;
        h3 {
          line-height: 50px;
          font-size: 20px;
          color: #2e334c;
        }
        /deep/ .el-button{
          min-height: 0;
          padding: 0;
          color: #fff;
          font-size: 13px;
        }
        /deep/ .el-form-item{
          margin-bottom: 10px;
          .el-form-item__label {
            padding-bottom: 0;
            line-height: 28px;
          }
          .el-form-item__content{
            line-height: 100%;
          }
          .el-input__inner {
            border-radius: 0;
          }
        }
        
        .user-info {
          position: relative;
          height: 188px;
          padding: {
            left: 20px;
            right: 18px;
            bottom: 10px;
          }
          p {
            text-align: left;
            line-height: 32px;
            @include ellipsis;
          }
          .user-btns {
            position: absolute;
            left: 0;
            bottom: 8px;
            width: 100%;
          }
          .change-pwd__btn {
            width: 90px;
            height: 30px;
            background-color: #1895dd;
            border-radius: 4px;
            &:hover {
              background-color: #36a9ec;
            }
            &:focus {
              background-color: #0581c9;
            }
          }
        }
        .logout-box {
          height: 41px;
          line-height: 40px;
          border: {
            top: 1px solid #eee;
          }
          text-align: center;
          .logout__btn {
            font-size: 14px;
            color: #26282e;
            border: 0;
            background: url(~@/assets/images/icon-exit.png) no-repeat left
              center;
            padding: {
              top: 0;
              bottom: 0;
              left: 26px;
            }
          }
        }
        .change-pwd__wrapper {
          .close__btn {
            top: 0px;
            position: absolute;
            right: 5px;
            background: 0;
            border: 0;
            font-size: 18px;
            color: #81878d;
          }
        }
        .popper__arrow {
          &,
          &::after {
            border-width: 6px;
            position: absolute;
            width: 0;
            height: 0;
            border-color: transparent;
            border-style: solid;
          }
        }
        .popper__arrow {
          filter: drop-shadow(0 2px 12px rgba(0, 0, 0, 0.03));
          top: -7px;
          right: 12px;
          border-style: solid;
          border-width: 6px;
          border-top-width: 0;
          border-bottom-color: #f2f5f8;
          margin-left: 3px;
          &::after {
            content: " ";
            top: 1px;
            margin-left: -6px;
            border-top-width: 0;
            border-bottom-color: #fff;
          }
        }
      }
      &:hover {
        .logined-drop {
          display: block;
        }
      }
    }

    .vertical__span {
      display: inline-block;
      vertical-align: top;
      font-size: 18px;
      color: #262f52;
      margin: {
        left: 30px;
        right: 20px;
      }
    }

    .logout {
      padding: 0;
      background: transparent;
      border: none;
      outline: none;
      cursor: pointer;
      display: inline-block;
      vertical-align: top;
      .icon-logout {
        display: block;
        width: 20px;
        height: 27px;
        margin-top: 12px;
      }
    }
  }

  .main-wrap {
    flex: auto;
    overflow: hidden;
    height: calc(100% - 50px);

    .tabs-box {
      height: 100%;
      overflow: hidden;
      display: flex;
      flex: auto;
      flex-direction: column;
      /deep/ .el-tabs__active-bar{
        display: none;
      }
    }
  }

  .tabs-nav-wrapper {
    height: 30px;
    overflow: hidden;
    padding: 0;
    background-color: #e4e4eb;
  }
  .open-board,
  .tabs-nav-box {
    display: inline-block;
    vertical-align: top;
  }
  .open-board {
    position: relative;
    width: 40px;
    height: 30px;
    background-color: #e4e4e4;
    .icon-menu {
      display: inline-block;
      width: 40px;
      height: 30px;
      background-repeat: no-repeat;
      background-position: center;
      background-image: url(~@/assets/images/icon-menu.png);
      cursor: pointer;
    }
  }

  .tabs-nav-box {
    height: 30px;
    width: calc(100% - 40px);
  }

  .content-wrapper {
    height: calc(100% - 30px);
    overflow: hidden;
    // padding: 20px 16px 24px 20px;
    flex: auto;
    &.no-padding {
      padding: 0;
      .content-page {
        border: none;
      }
    }
    .content-page {
      height: calc(100% - 44px);
      background-color: #fff;
      border: 1px solid #eee;
      margin: 20px 16px 24px 20px;
    }
  }
}
</style>

<style lang="scss">
@import "@/styles/menu.scss";

.tabs-nav-wrapper {
  .el-tabs__header {
    padding: 0;
    position: relative;
  }
  .el-tabs__nav-wrap {
    overflow: hidden;
    margin-bottom: -1px;
    position: relative;
    &.is-scrollable {
      padding: 0 20px;
      box-sizing: border-box;
    }
  }
  .el-tabs__nav-next,
  .el-tabs__nav-prev {
    position: absolute;
    width: 20px;
    background-color: #eeeef1;
    color: #909399;
    text-align: center;
    line-height: 30px;
    font-size: 12px;
    cursor: pointer;
    &:hover {
      color: #545c66;
    }
  }
  .el-tabs__nav-prev {
    left: 0;
  }
  .el-tabs__nav-next {
    right: 0;
  }
  .el-icon-arrow-left,
  .el-icon-arrow-right {
    font-weight: 700;
  }
  .el-tabs__nav-scroll {
    overflow: hidden;
  }
  .el-tabs__nav {
    white-space: nowrap;
    position: relative;
    transition: transform 0.3s;
    float: left;
    z-index: 2;
  }
  .el-tabs__item {
    min-width: 160px;
    padding: 0 10px!important;
    height: 30px;
    line-height: 30px;
    display: inline-block;
    list-style: none;
    font-size: 12px;
    color: #535353;
    background-color: #eeeef1;
    border-right: 1px solid #d9d9df;
    position: relative;
    cursor: pointer;
    .el-icon-close {
      color: #545c66;
      border-radius: 50%;
      text-align: center;
      width: 14px;
      position: absolute;
      right: 10px;
      top: 8px;
      font-weight: bold;
    }
    &:hover {
      background-color: #d6d6d8;
      color: #545c66;
    }
    &.is-active {
      background-color: #fff;
      color: #545c66;
      .el-icon-close {
        color: #545c66;
      }
    }
    &:focus,
    &.el-tabs__item:focus:active {
      outline: none;
    }
  }
}
// 下拉搜索无数据
.el-select-dropdown {
  font-size: 8px;
  .is-empty {
    display: none;
  }
  .el-select-dropdown__empty {
    font-size: 12px;
    color: #aaa;
    padding-left: 10px;
    line-height: 24px;
  }
}
.untying {
  font-size: 13px;
  font-weight: 500;
  text-decoration: underline;
  color: rgba(83, 83, 83, 1);
  position: absolute;
  bottom: 60px;
  right: 24px;
}
</style>

